import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Copy from './copy.js';
import Radio from './radio.js';
const AsidePill = styled(Copy).withConfig({ displayName: "brc-AsidePill", componentId: "brc-t10dxb" }) `
  background-color: ${({ theme }) => theme.mermaidGreen200};
  padding: 4px 8px;
  border-radius: 12px;
  display: inline-block;
`;
const Toggles = styled.div.withConfig({ displayName: "brc-Toggles", componentId: "brc-1t084s9" }) `
  display: flex;
  flex-wrap: wrap;

  & > ${Radio} {
    min-width: 240px;
    margin: 8px;
    padding: 0 16px;
  }
`;
export default ({ asideContent, toggleA, toggleB, toggleCondition, toggleCallback }) => (_jsxs(Toggles, { children: [_jsx(Radio, { "data-testid": `upgrade-plan-page:${toggleA}-radio-toggle`, checked: !toggleCondition, label: toggleA, onChange: () => {
                toggleCallback(!toggleCondition);
            }, checkedBackgroundColor: ({ theme }) => theme.neutral100, hasBorder: true }), _jsx(Radio, { "data-testid": `upgrade-plan-page:${toggleB}-radio-toggle`, checked: toggleCondition, label: toggleB, hasBorder: true, onChange: () => {
                toggleCallback(!toggleCondition);
            }, checkedBackgroundColor: ({ theme }) => theme.neutral100, asideContent: _jsx(AsidePill, Object.assign({ size: "xs" }, { children: asideContent })) })] }));
//# sourceMappingURL=wrapped-ab-content-toggle.js.map